// 此文件由脚本自动生成，请勿直接修改。
// This file was generated automatically by a script. Please do not modify it directly.

import { CardTokens } from './type';

const cardTokens: CardTokens = {
  cardBackgroundColor: 'Neutral-fill-1',
  cardShadow: 'Shadow-2',
  cardBorderColor: 'Neutral-border-1',
  cardBorderRadius: 'Radius-4',
  cardFontColor: 'Neutral-text-5',
  cardFontSize: '14/regular',
  cardPaddingX: 'Padding-16',
  cardPaddingY: 'Padding-12',
  cardTitleFontSize: '16/medium',
  cardHeaderGap: '8px',
  cardHeaderExtraMarginX: 'Margin-16',
  cardIndicatorSize: 'Size-7',
  cardIndicatorColor: 'Neutral-text-4',
};

export default cardTokens;
